module.exports = __webpack_public_path__ + "media/images/door-icon-723a9d6ea1c5976cccd83892b2842f12.svg";